import HttpClient from "libs/utils/HttpClient";

class ConfigTimeService {


  async getconfigtime() {
    try {


      const response = await HttpClient.get(`/api/configtime/list`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async updateconfigtime(body) {
    try {
      const response = await HttpClient.post(`/api/configtime/update`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async approveConfigTimes(body) {
    try {
      const response = await HttpClient.post(`/api/configtime/approve`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

}

export default new ConfigTimeService();

